import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageOrderderService } from 'src/app/shared/services/manage-orderder.service';

@Component({
  selector: 'app-add-event-popup',
  templateUrl: './add-event-popup.component.html',
  styleUrls: ['./add-event-popup.component.scss','../../../modules/dashboard/organization-dash/organization-dash.component.scss']
})
export class AddEventPopupComponent implements OnInit {

  currentTime: any = "";
  todayDate: Date = new Date();

  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubServ: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,) { }

  eventForm = this.fb.group({
    title: new FormControl('', [Validators.required]),
    date: new FormControl('', [Validators.required]),
    team: new FormControl('', [Validators.required]),
    comment: new FormControl(''),
    delivary: new FormControl('', [Validators.required]),
  })
  
  ngOnInit(): void {
    this.getTeamListAPICall();
  }

  teamList: any;

  getTeamListAPICall() {
    try {
      let request = {
        "pageLimit": 100,
        "page": 1
      }
      console.log(request);
      this.clubServ.getTeamList(request).subscribe(
        (res: any) => {
          this.teamList = res.output.list;
          this.spinner.hide();
        },
        (err: any) => {
          // this.toast.error("Error on fetch events");
          this.spinner.hide();
        }
      )
    }
    catch (e) { }
  }

  teamArr: any = [];

  selectTeams(e: any, id: any) {
    // e.target.checked
    if (e.checked == true) {
      this.teamArr.push(id);
      for(var i of this.teamList){
        if(i?._id ==id){
          i['selected']= true
        }
      }
      // console.log(this.teamArr, "ooooo")
    } else {
      this.teamArr = this.teamArr.filter((data:any)=>{
        return data != id
      })

      for(var i of this.teamList){
        if(i?._id ==id){
          i['selected']= false
        }
      }
      // var index = this.teamArr.indexOf(id);
      // this.teamArr.splice(index, 1);
      // console.log(this.teamArr, "mmm")

    };
    this.eventForm.get('team').patchValue(this.teamArr);
    
  }

  deleveryTimeVal:any;
  onTimeChange(e) {
    // let timearr = e.toLocaleTimeString('en-US').split(":");
    let dateString = new Date();
    dateString.setHours(e.target.value.split(":")[0]);
    dateString.setMinutes(e.target.value.split(":")[1]);
    let timearr = dateString.toLocaleTimeString('en-US').split(":");
    let hours = timearr[0];
    let minutes = timearr[1];
    let meridian = timearr[2].substring(3);

    console.log(hours + ':' + minutes + ' ' + meridian);

    this.deleveryTimeVal = hours + ':' + minutes + ' ' + meridian;
    this.eventForm.controls.delivary.setValue(dateString.toString());
  }

  @Output() eventFormData = new EventEmitter();
  @Output() closePopup = new EventEmitter();

  // onclickNext() {
  //   try {
  //     console.log(this.eventForm.value, "eventForm");
  //     // this.modalRef.hide();
  //     // this.openModal(this.selectresturent);
  //     this.eventFormData.emit({eventDetails : this.eventForm.value, deleveryTimeVal : this.deleveryTimeVal});
  //   }
  //   catch (e) { }
  // }

  onclickNext() {
    try {
      console.log(this.eventForm.value, "eventForm");
  
      const selectedDateStr = this.eventForm.value.date;          // Get selected date (string)
      const selectedTimeStr = this.eventForm.value.delivary;       // Get selected time (full date-time string)
  
      if (!selectedDateStr || !selectedTimeStr) {
        this.toast.error("Please select both date and time.");
        console.log("❌ Missing date or time!");
        return;  // Stop execution
      }
  
      // Convert date string to JavaScript Date
      const selectedDate = new Date(selectedDateStr);
      const selectedTime = new Date(selectedTimeStr);
  
      if (isNaN(selectedDate.getTime()) || isNaN(selectedTime.getTime())) {
        this.toast.error("Invalid date or time selected. Please try again.");
        console.log("❌ Invalid Date or Time Selected!");
        return;  // Stop execution if date or time is invalid
      }
  
      // Combine date and time into a single Date object
      selectedDate.setHours(selectedTime.getHours(), selectedTime.getMinutes(), 0, 0);
  
      // Get current date and time
      const currentDateTime = new Date();
  
      // Debugging logs
      console.log("📅 Current DateTime:", currentDateTime);
      console.log("📅 Selected DateTime:", selectedDate);
  
      // Calculate the difference in milliseconds
      const timeDifference = selectedDate.getTime() - currentDateTime.getTime();
  
      // Convert difference to hours
      const hoursDifference = timeDifference / (1000 * 60 * 60);
  
      // Log the difference in hours
      console.log("🕒 Hours Difference:", hoursDifference);
  
      // Check if the selected date-time is at least 24 hours ahead
      if (hoursDifference < 24) {
        this.toast.error("Event cannot be added 24 hours before the start time");
        console.log("❌ Event cannot be added 24 hours before the start time");
        return;  // Stop execution if within 24 hours
      }
  
      // Emit event if validation passes
      console.log("✅ Event added successfully!");
      // this.toast.success("Event added successfully!");
      this.eventFormData.emit({ eventDetails: this.eventForm.value, deleveryTimeVal: this.deleveryTimeVal });
    } catch (e) {
      console.error("❌ Error in onclickNext:", e);
      this.toast.error("Something went wrong. Please try again.");
    }
  }
  
  
  
  

  closeModal() {
    // this.modalRef.hide();
    // this.delieveryCheckBoxText = undefined;
    // this.checkedVal = false;
    this.closePopup.emit();
    this.eventForm.reset();
    // this.selectForm.reset();
    // this.checkForm.reset();
  }

  onClosed(){
    console.log("on closed called");
    // formControl.control.markAsTouched();
    let elem = document.getElementsByClassName("mat-form-field mat-form-field-invalid datepicker")[0]?.getElementsByClassName("mat-form-field-ripple")[0];
    // debugger;
    elem?.setAttribute("style","height: 7px !important;background-color: transparent;border-bottom: 1px solid #f44336;border-radius: 10px !important;");
    if(!elem){
      console.log(elem);
      console.log("elem not found");
      console.log("trying again");
      setTimeout(()=>{
        let elem = document.getElementsByClassName("mat-form-field mat-form-field-invalid datepicker")[0]?.getElementsByClassName("mat-form-field-ripple")[0];
        // debugger;
        elem?.setAttribute("style","height: 7px !important;background-color: transparent;border-bottom: 1px solid #f44336;border-radius: 10px !important;");
      },1000)
    }
  }
}
